module.exports = __webpack_public_path__ + "static/media/KaTeX_SansSerif-Regular.f9e06d59.woff2";